// 组件
import importImg from '@/components/importImg.vue'
import alterForm from '@/components/alterForm'
// 接口
import { getHotelRoomsCollections, postHotelRoomsAdd } from '@/services/rooms.js'
// 其他
import loading from '@/utils/loading.json'
import jsonData from './jsonData'
import constant from '@/utils/constant.js'

export default {
  components: {
    importImg,
    alterForm
  },
  data () {
    return {
      modifyData: {},
      collapseLength: [],
      formData: jsonData.formData
    }
  },
  watch: {
  },
  created () {
    this.init()
  },
  mounted () {
  },
  methods: {
    init () {
      this.collapseLength = [...new Array(this.formData.length).keys()]
      this.$store.state.app.loading = this.$loading(loading)
      getHotelRoomsCollections().then(res => {
        if (res.status === 200) {
          this.formData[0].createDateItem[1].options = res.data.collections.hotels
          this.formData[0].createDateItem[2].options = res.data.collections.bed_types
        }
      }).finally(() => {
        this.$store.state.app.loading.close()
      })
    },
    formSubmit (data) {
      this.$store.state.app.loading = this.$loading(loading)
      const obj = JSON.parse(JSON.stringify(data))
      const params = {
        hotel_room: obj
      }
      Object.keys(params.hotel_room).forEach(res => {
        if (typeof params.hotel_room[res] === 'boolean') {
          if (params.hotel_room[res] === true) params.hotel_room[res] = '1'
          if (params.hotel_room[res] === false) params.hotel_room[res] = '0'
        }
      })
      postHotelRoomsAdd(params).then(res => {
        if (res.status === 200) {
          this.$message({
            type: 'success',
            message: this.$t('message.operateSuccess')
          })
          setTimeout(() => {
            this.$router.push({
              name: 'hotelRoomList'
            })
          }, constant.ROUTER_CHANGE_INTERVAL)
        }
      }).finally(() => {
        this.$store.state.app.loading.close()
      })
    }
  }
}
